export default __webpack_public_path__ + "static/media/W_wdt_c_cap_2.a77e2586.mp3";